import { useSession } from '~/contexts/SessionContext';
import { createStructureSetListItemView } from '~/domain/projections/factories';
import { StructureSetListItemView } from '~/domain/projections/views';
import { useDomainProjection } from './useDomainProjection';

const NO_ITEMS: readonly StructureSetListItemView[] = [];

export function useStructureSetListView(): readonly StructureSetListItemView[] {
    return useDomainProjection(
        useSession(),
        'useStructureSetListView',
        [],
        (patient) => patient.structureSets.map(createStructureSetListItemView),
        NO_ITEMS
    );
}
